import React from "react";
import {
  Container,
  Row,
  Col,
  Card,
  ProgressBar,
  Breadcrumb,
} from "react-bootstrap";
import SEOHead from "../components/SEOHead";

const AboutPage: React.FC = () => {
  const stats = [
    {
      icon: "📅",
      number: "13+",
      label: "Years Experience",
      description: "Serving Indore since 2011",
    },
    {
      icon: "👥",
      number: "5000+",
      label: "Happy Customers",
      description: "Satisfied vehicle owners",
    },
    {
      icon: "🏆",
      number: "12",
      label: "Services Offered",
      description: "Complete car care solutions",
    },
    {
      icon: "📍",
      number: "1",
      label: "Service Center",
      description: "Convenient Limbodi location",
    },
  ];

  const skills = [
    {
      name: "Car Denting & Painting",
      percentage: 95,
      description: "Expert body work and color matching",
    },
    {
      name: "Mechanical Repairs",
      percentage: 90,
      description: "Engine, transmission, and brake expertise",
    },
    {
      name: "AC Services",
      percentage: 88,
      description: "Cooling system specialists",
    },
    {
      name: "Regular Maintenance",
      percentage: 92,
      description: "Preventive care and servicing",
    },
  ];

  const timeline = [
    {
      year: "2011",
      event: "Laxmi Tyre & Motors established in Limbodi, Indore",
    },
    {
      year: "2015",
      event: "Expanded services to include comprehensive car care",
    },
    { year: "2018", event: "Reached milestone of 2000+ satisfied customers" },
    { year: "2021", event: "Introduced modern diagnostic equipment" },
    { year: "2024", event: "Serving 5000+ customers with 4.8★ rating" },
  ];

  return (
    <>
      <SEOHead page="about" />

      {/* Breadcrumb */}
      <Container className="py-3">
        <Breadcrumb>
          <Breadcrumb.Item href="#home">Home</Breadcrumb.Item>
          <Breadcrumb.Item active>About Us</Breadcrumb.Item>
        </Breadcrumb>
      </Container>

      {/* About Header */}
      <section className="py-5 bg-primary text-white">
        <Container>
          <div className="text-center">
            <h1 className="display-4 fw-bold mb-3">
              About Laxmi Tyre & Motors
            </h1>
            <p className="lead mb-0">
              Your trusted automobile service partner in Indore since 2011
            </p>
          </div>
        </Container>
      </section>

      {/* Main About Content */}
      <section className="py-5">
        <Container>
          <Row className="align-items-center">
            <Col lg={12} className="mb-4">
              <h2 className="h3 fw-bold text-dark mb-4">Our Story</h2>
              {/* <p className="text-muted mb-4">
                <strong>Established in 2011</strong>, Laxmi Tyre and Motors has been serving the automobile 
                repair and maintenance needs of Indore with unwavering dedication and expertise. What started 
                as a small workshop has grown into one of the most trusted car service centers in the region.
              </p>
              <p className="text-muted mb-4">
                We are a <strong>professional car service provider</strong> specializing in expert denting and painting 
                services, along with comprehensive vehicle maintenance. Our team of skilled technicians uses 
                modern equipment and genuine parts to ensure your vehicle receives the best care possible.
              </p>
              <p className="text-muted mb-4">
                Located in <strong>Limbodi, Indore</strong>, we have built a reputation for quality workmanship, 
                honest pricing, and exceptional customer service. Whether it's a minor scratch or major 
                mechanical repair, we treat every vehicle with the same level of care and attention to detail.
              </p> */}

              <p className="text-muted mb-4">
                <strong>About Laxmi Tyres & Motors</strong>
              </p>

              <p className="text-muted mb-4">
                Laxmi Tyres & Motors is a leading multi-brand automobile service
                and repair center located in Limbodi, Indore (Madhya Pradesh),
                delivering reliable and professional automotive solutions for
                over 12 years. We specialize in complete car care services,
                combining modern diagnostic technology with skilled workmanship
                to ensure superior service quality and long-term vehicle
                performance.
              </p>

              <p className="text-muted mb-4">
                Our facility is equipped with advanced tools and infrastructure
                to handle everything from routine maintenance to complex
                mechanical repairs. We are widely recognized for our precision
                wheel alignment, computerized balancing, professional paint
                shop, and body repair services, ensuring optimal handling,
                safety, and visual restoration of your vehicle.
              </p>

              <p className="text-muted mb-4">
                Our certified technicians follow systematic inspection
                procedures and manufacturer-recommended service standards to
                accurately diagnose faults and provide cost-effective,
                long-lasting solutions. Whether it is suspension repair, AC
                servicing, denting & painting, battery diagnostics, clutch
                repair, or full car servicing, every job is performed with
                strict quality control and genuine spare parts.
              </p>

              <p className="text-muted mb-4">
                At Laxmi Tyres & Motors, customer satisfaction, transparency,
                and technical excellence are the foundation of our service
                philosophy. We are committed to delivering safe, efficient, and
                dependable automotive care that enhances your vehicle's
                performance, safety, and lifespan.
              </p>

              <p className="text-muted mb-4">
                Trust Laxmi Tyres & Motors – Indore's dependable destination for
                professional auto repair and maintenance.
              </p>
              {/* Mission & Vision */}
            
            </Col>

            <Col lg={12}>
              {/* Stats */}
              <Row>
                {stats.map((stat, index) => (
                  <Col sm={3} className="mb-3" key={index}>
                    <Card className="text-center border-0 shadow-sm h-100">
                      <Card.Body>
                        <div className="display-6 mb-2">{stat.icon}</div>
                        <h3 className="fw-bold text-primary mb-1">
                          {stat.number}
                        </h3>
                        <h6 className="fw-bold mb-1">{stat.label}</h6>
                        <p className="small text-muted mb-0">
                          {stat.description}
                        </p>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Col>
              <Row className="mt-4">
                <Col sm={6} className="mb-3">
                  <Card className="border-primary h-100">
                    <Card.Body className="text-center">
                      <div className="text-primary display-6 mb-2">🎯</div>
                      <h5 className="fw-bold">Our Mission</h5>
                      <p className="small mb-0">
                        To provide reliable, quality automobile services that
                        keep your vehicle running safely and efficiently.
                      </p>
                    </Card.Body>
                  </Card>
                </Col>
                <Col sm={6} className="mb-3">
                  <Card className="border-success h-100">
                    <Card.Body className="text-center">
                      <div className="text-success display-6 mb-2">👁️</div>
                      <h5 className="fw-bold">Our Vision</h5>
                      <p className="small mb-0">
                        To be Indore's most trusted and preferred automobile
                        service center for all car brands.
                      </p>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
          </Row>
        </Container>
      </section>

      {/* Skills & Expertise */}
      <section className="py-5 bg-light">
        <Container>
          <div className="text-center mb-5">
            <h2 className="h3 fw-bold text-dark mb-3">Our Expertise</h2>
            <p className="text-muted">
              Years of experience have made us experts in various automobile
              services
            </p>
          </div>

          <Row>
            <Col lg={8} className="mx-auto">
              {skills.map((skill, index) => (
                <div key={index} className="mb-4">
                  <div className="d-flex justify-content-between mb-2">
                    <div>
                      <span className="fw-bold">{skill.name}</span>
                      <p className="small text-muted mb-0">
                        {skill.description}
                      </p>
                    </div>
                    <span className="text-primary fw-bold">
                      {skill.percentage}%
                    </span>
                  </div>
                  <ProgressBar
                    now={skill.percentage}
                    variant="primary"
                    style={{ height: "10px" }}
                  />
                </div>
              ))}
            </Col>
          </Row>
        </Container>
      </section>

      {/* Timeline */}
      <section className="py-5">
        <Container>
          <div className="text-center mb-5">
            <h2 className="h3 fw-bold text-dark mb-3">Our Journey</h2>
            <p className="text-muted">
              Milestones in our journey of serving the automobile community
            </p>
          </div>

          <Row>
            <Col lg={8} className="mx-auto">
              {timeline.map((item, index) => (
                <div key={index} className="d-flex mb-4">
                  <div
                    className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-3"
                    style={{ width: "60px", height: "60px", minWidth: "60px" }}
                  >
                    <strong>{item.year}</strong>
                  </div>
                  <div className="pt-2">
                    <p className="mb-0 text-muted">{item.event}</p>
                  </div>
                </div>
              ))}
            </Col>
          </Row>
        </Container>
      </section>

      {/* Why Choose Us */}
      <section className="py-5 bg-dark text-white">
        <Container>
          <div className="text-center mb-5">
            <h2 className="h3 fw-bold mb-3">Why Choose Laxmi Tyre & Motors?</h2>
            <p className="text-light">
              What makes us the preferred choice for car owners in Indore
            </p>
          </div>

          <Row>
            <Col md={4} className="mb-4">
              <Card className="bg-transparent border-light text-white text-center h-100">
                <Card.Body>
                  <div className="text-success display-6 mb-3">✓</div>
                  <h5 className="fw-bold">Quality Assurance</h5>
                  <p className="mb-0">
                    We use only genuine parts and follow manufacturer guidelines
                    to ensure the highest quality of service for your vehicle.
                  </p>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4} className="mb-4">
              <Card className="bg-transparent border-light text-white text-center h-100">
                <Card.Body>
                  <div className="text-warning display-6 mb-3">⚡</div>
                  <h5 className="fw-bold">Quick Turnaround</h5>
                  <p className="mb-0">
                    Efficient service delivery without compromising on quality.
                    Most services are completed within the same day.
                  </p>
                </Card.Body>
              </Card>
            </Col>
            <Col md={4} className="mb-4">
              <Card className="bg-transparent border-light text-white text-center h-100">
                <Card.Body>
                  <div className="text-info display-6 mb-3">💰</div>
                  <h5 className="fw-bold">Transparent Pricing</h5>
                  <p className="mb-0">
                    No hidden charges. We provide detailed estimates before
                    starting any work on your vehicle.
                  </p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default AboutPage;
